<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>{{ rowId ? '信息编辑' : '信息创建' }}</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/recruit')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <el-form
        :model="formData"
        :rules="rules"
        label-width="130px"
        ref="formData"
      >
        <el-form-item label="排序" prop="sort">
          <el-input clearable v-model="formData.sort" type="number"> </el-input>
        </el-form-item>
        <el-form-item label="职位名称" prop="jobTitle">
          <el-input clearable v-model="formData.jobTitle"> </el-input>
        </el-form-item>

        <el-form-item label="岗位职责" prop="jobDescription">
          <el-input clearable v-model="formData.jobDescription" type="textarea">
          </el-input>
        </el-form-item>
        <el-form-item label="任职要求" prop="content">
          <el-input clearable v-model="formData.content" type="textarea">
          </el-input>
        </el-form-item>
        <el-form-item label="工作地点" prop="location">
          <el-input clearable v-model="formData.location"> </el-input>
        </el-form-item>
        <el-form-item label="薪资范围" prop="salaryRange">
          <el-input clearable v-model="formData.salaryRange"> </el-input>
        </el-form-item>
        <!-- <el-form-item label="联系电话/邮箱" prop="contactInfo">
          <el-input clearable v-model="formData.contactInfo"> </el-input>
        </el-form-item> -->
        <!-- <el-form-item label="所需的工作经验年限" prop="experienceRequired">
          <el-input clearable v-model="formData.experienceRequired"> </el-input>
        </el-form-item>
        <el-form-item label="所需的最低学历" prop="educationRequired">
          <el-input clearable v-model="formData.educationRequired"> </el-input>
        </el-form-item> -->
        <!-- <el-form-item label="图片" prop="imagePath">
          <el-upload
            class="avatar-uploader"
            action="#"
            multiple
            accept=".jpeg,.png,.jpg"
            list-type="picture-card"
            :http-request="photoUpload"
            :on-change="photoChange"
            :on-remove="photoRemove"
            :on-exceed="photoExceed"
            :before-upload="checkFileType"
            :limit="1"
            :file-list="photoList"
            :class="{ hide: this.photoList.length >= 1 }"
          >
            <i slot="default" class="el-icon-plus" />
          </el-upload>
        </el-form-item> -->
        <el-form-item label="备注" prop="remark">
          <el-input clearable v-model="formData.remark" type="textarea">
          </el-input>
        </el-form-item>
        <div
          class="button-group"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="submitFn"
          >
            <span>保存</span>
          </el-button>
          <el-button
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="reset"
          >
            <!-- <i v-if="item.icon" :class="item.icon"></i> -->
            <span>重置</span>
          </el-button>
        </div>
      </el-form>
      <!-- <tz-form
        width="130px"
        :formConfig="formConfig"
        :formBtns="formBtns"
        @submit="submitFn"
        @cleanFn="resultClean"
      ></tz-form> -->
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addList, getId, updateList } from '@/api/recruit'
// import MyEditor from './components/MyEditor.vue'
import { uploadFile } from '@/api/advertising'
// import { sort } from 'core-js/core/array'

export default {
  // components: { MyEditor },

  data() {
    return {
      resultSelect: true,
      formData: {},
      itemList: [],
      photoList: [],
      rowId: null,
      rules: {
        jobTitle: [{ required: true, message: '职位名称必填', trigger: 'blur' }]
        // type: [{ required: true, message: '类型必填', trigger: 'blur' }]
        // content: [{ required: true, message: '内容必填', trigger: 'blur' }]
      }
    }
  },

  mounted() {
    let rowId = this.$route.query.id
    if (rowId && rowId != 'null') {
      this.rowId = rowId
      this.handleUpdate(this.rowId)
    } else {
      this.reset()
    }
  },
  methods: {
    /** 修改按钮操作 */
    handleUpdate(row) {
      // let deviceRow = []
      // let deviceIds = []
      this.reset()
      // const id = row.id || this.ids
      getId({ id: row }).then((response) => {
        let formData = response.data
        // deviceIds.push(row.deviceId)
        // deviceRow.push({ id: row.deviceId, propertyNum: row.propertyNum })
        // this.form.deviceIds = deviceRow
        // this.open = true
        // this.title = '修改设备检测记录'
        // if (
        //   formData.type !== '' &&
        //   formData.type !== null &&
        //   formData.type !== undefined
        // ) {
        //   formData.type = Number(formData.type)
        // }
        if (formData.imagePath) {
          this.photoList.push({
            url: this.getImgUrl(formData.imagePath)
          })
        }
        this.formData = formData
        console.log(this.photoList)
      })
    },
    // 上传照片
    photoUpload() {
      this.formData.imagePath = ''
      const formData = new FormData()
      this.photoList.forEach((el) => {
        console.log(el)
        formData.append('multipartFile', el.raw)
      })
      this.$loading({
        text: '图片上传中'
      })
      uploadFile(formData).then((res) => {
        console.log(res.data, '创建')
        if (res.code == 200) {
          this.formData.imagePath = res.data.uploadUrl
          this.$message({
            message: '上传成功',
            type: 'success'
          })
          this.$loading().close()
        } else {
          this.formData.imagePath = ''
          this.$message({
            message: '上传失败',
            type: 'success'
          })
          this.photoList = []
          this.$loading().close()
        }
      })
    },
    //移除头像
    photoRemove(file, fileList) {
      this.photoList = fileList
      this.formData.imagePath = ''
    },
    // 照片类型限制
    checkFileType(file) {
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))
      // jpeg,.png,.jpg,.bmp,.gif
      if (fileType === '.jpg' || fileType === '.png' || fileType === '.jpeg') {
        // 不处理
        console.log('格式正确')
      } else {
        this.$message.error('不是.jpeg,.png,.jpg文件,请上传正确的图片类型')
        return false
      }
    },

    //头像超限制
    photoExceed(files, fileList) {
      console.log(files, fileList)

      this.$message.error(`只允许一次性上传1张图片`)
    },
    photoChange(file, fileList) {
      console.log(this.fileList, 'change')

      this.photoList = fileList
      //获取上传文件大小
      let imgSize = Number(file.size / 1024 / 1024)
      if (imgSize > 1000) {
        this.$msgbox({
          title: '',
          message: '文件大小不能超过1000MB，请重新上传。',
          type: 'warning'
        })
        this.photoList = []
        return
      }
      this.photoList = fileList
    },
    // 重置
    clearFn() {
      this.resultSelect = true
      this.$refs['formData'].resetFields()
    },
    // 表单重置
    reset() {
      this.formData = {
        id: null,
        jobTitle: null,
        jobDescription: null,
        sort: null,
        content: null,
        salaryRange: null,
        location: null,
        contactInfo: null,
        jobType: null,
        experienceRequired: null,
        educationRequired: null,
        remark: null,
        imagePath: null
      }
      this.$refs['formData'].resetFields()
    },

    // 提交
    submitFn() {
      // console.log(this.$refs.editor.html, '报告创建')
      // this.formData.content = this.$refs.editor.html
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          if (this.submited) return
          // this.$loading({
          //   text: '报告添加中'
          // })

          if (this.formData.id == null) {
            addList(this.formData).then((res) => {
              console.log(res.data, '创建')
              if (res.code == 200) {
                this.submited = true
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.$router.go(-1)
              } else {
                this.$message({
                  message: res.data,
                  type: 'error'
                })
              }
            })
            this.$loading().close()
          } else {
            updateList(this.formData).then((res) => {
              console.log(res.data, '创建')
              if (res.code == 200) {
                this.submited = true
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.$router.go(-1)
              } else {
                this.$message({
                  message: res.data,
                  type: 'error'
                })
              }
            })
            this.$loading().close()
          }
        } else {
          this.$message({
            message: '请输入必填项',
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
  display: none;
}
</style>
